import * as yup from "yup";
import regEx from "../../../../../shared/validations/regularExpression";
import { getValidationSchema } from "../../../../../shared/validations/schema";
export const customizeValidationSchema = () => {
  let defaultSchema: any = getValidationSchema([
    "oldPassword",
    "newPassword",
    "confirmPassword",
  ]);

  let customSchema = yup.object().shape({});

  return defaultSchema.concat(customSchema);
};

export const customizeProfileValidationSchema = (editStatus?: boolean) => {
  let defaultSchema: any = getValidationSchema([
    "email",
    "phone",
    "gender",
  ]);

  let customSchema = yup.object().shape({
    fullName: yup
      .string()
      .trim()
      .required("Name is required")
  });

  return defaultSchema.concat(customSchema);
};
